import styled from 'styled-components';
import { FC, useEffect } from 'react';
import { UserResponseDtoRoleEnum } from '@app/api';
import { StepperProvider, useStepper } from '@app/components/Stepper';
import { SignUpStepsLabels } from '@app/types';
import { signUpStepsModal } from '@app/pageComponents/SignUpPage/common';
import { SignUpModalPage } from '@app/pageComponents/SignUpPage/SignUp';
import {
  loginStepsModal,
  SignInSteps,
} from '@app/pageComponents/LoginPage/Login/common';
import { LoginModalPage } from '@app/pageComponents/LoginPage/Login';
import { useAppSelector, useAppDispatch } from '@app/store/hooks';
import { actions, selectors } from '@app/store';

const SignUpModal: FC = () => {
  const dispatch = useAppDispatch();
  const activeTab = useAppSelector(selectors.auth.selectActiveTab);

  const signUpStepper = useStepper({
    steps: signUpStepsModal(UserResponseDtoRoleEnum.Patient),
    defaultStep: SignUpStepsLabels.enterPhone,
  });

  const loginStepper = useStepper({
    steps: loginStepsModal,
    defaultStep: SignInSteps.CHOOSE_WAY,
  });

  const PAGES = {
    REGISTER: 'register',
    LOGIN: 'login',
  };

  useEffect(() => {
    dispatch(
      actions.auth.setSignUpContext({
        mode: 'modal',
      }),
    );
  }, []);

  return (
    <Root>
      {activeTab === PAGES.REGISTER && (
        <StepperProvider {...signUpStepper}>
          <SignUpModalPage />
        </StepperProvider>
      )}

      {activeTab === PAGES.LOGIN && (
        <StepperProvider {...loginStepper}>
          <LoginModalPage />
        </StepperProvider>
      )}
    </Root>
  );
};

export default SignUpModal;

const Root = styled.div`
  width: 100%;
`;
